<template>
	<section id="hallbarhet" class="w-100 bg-white">
		<b-row v-view="viewHandler">
			<b-col cols="12" lg="6" offset-lg="3" class="pt-lg-3 text-center viewer fade">
				<h3 class="pb-3">
					<span v-if="$creo.getLang() == 'sv'">Hållbart och ansvarsfullt samhällsbyggande</span>
					<span v-else>Sustainable and responsible urban planning</span>

				</h3>
			</b-col>
		</b-row>
		<b-row v-view="viewHandler">
			<b-col cols="10" offset="1" lg="8" offset-lg="2" class="pb-2 text-center viewer fade px-3">
				<p class="m-0">
					<span v-if="$creo.getLang() == 'sv'">JM bidrar till att skapa väl fungerande samhällen för dagens och morgondagens människor – de hus JM bygger idag brukas i minst 100 år. Som en ledande projektutvecklare av bostäder är hållbarhet vårt ansvar och vår ambition.</span>
					<span v-else>
						JM helps create well-functioning communities for the people
						of today and tomorrow – the buildings JM builds today will be used for
						at least 100 years. As a leading project developer of housing,
						sustainability is our responsibility and our ambition.
					</span>
				</p>
			</b-col>
		</b-row>
		<b-row v-view="viewHandler" class="pt-1">
			<b-col cols="12"  class="pt-4 viewer fade">
				<b-row class="d-flex justify-content-center px-3 px-lg-0">
					<b-col cols="7" lg="2"  class="text-center pt-4 pt-lg-5">
						<a :href="$creo.browserPdfLink(pdfLink.samhallet.org[$creo.getLang()], pdfLink.samhallet.fallback[$creo.getLang()], pdfLink.samhallet.page[$creo.getLang()])" target="_blank" class="d-block text-black text-decoration-none">
							<div class="img-hover-zoom">
								<b-img src="../assets/img/sam1.jpg" fluid/>
							</div>
							<p class="px-1 pt-3 small">
								<span v-if="$creo.getLang() == 'sv'">Hållbart samhällsbyggande</span>
								<span v-else>Sustainable urban planning</span>
							</p>
						</a>
					</b-col>
					<b-col cols="7" lg="2" class="text-center pt-4 pt-lg-5">
						<a :href="$creo.browserPdfLink(pdfLink.verksamhet.org[$creo.getLang()], pdfLink.verksamhet.fallback[$creo.getLang()], pdfLink.verksamhet.page[$creo.getLang()])" target="_blank" class="text-black text-decoration-none">
							<div class="img-hover-zoom">
								<b-img src="../assets/img/sam2.jpg" fluid/>
							</div>
							<p class="px-1 pt-3 small">
								<span v-if="$creo.getLang() == 'sv'">Verksamhetens miljöarbete</span>
								<span v-else>Environmental work</span>
							</p>
						</a>
					</b-col>
					<b-col cols="7" lg="2" class="text-center pt-4 pt-lg-5">
						<a :href="$creo.browserPdfLink(pdfLink.svanmarkta.org[$creo.getLang()], pdfLink.svanmarkta.fallback[$creo.getLang()], pdfLink.svanmarkta.page[$creo.getLang()])" target="_blank" class="text-black  text-decoration-none">
							<div class="img-hover-zoom">
								<b-img src="../assets/img/sam3.jpg" fluid/>
							</div>
							<p class="px-3 pt-3 small">
								<span v-if="$creo.getLang() == 'sv'">Svanenmärkta bostäder</span>
								<span v-else>Swan Ecolabel residential units</span>
							</p>
						</a>
					</b-col>
					<b-col cols="7" lg="2" class="text-center pt-4 pt-lg-5 d-none d-lg-flex">
						<a :href="$creo.browserPdfLink(pdfLink.kompetens.org[$creo.getLang()], pdfLink.kompetens.fallback[$creo.getLang()], pdfLink.kompetens.page[$creo.getLang()])" target="_blank" class="text-black  text-decoration-none">
							<div class="img-hover-zoom">
								<b-img src="../assets/img/sam4.jpg" fluid/>
							</div>
							<p class="px-1 pt-3 small">
								<span v-if="$creo.getLang() == 'sv'">Att utveckla hållbar kompetens</span>
								<span v-else>Developing sustainable skills    </span>
							</p>
						</a>
					</b-col>
					<b-col cols="7" lg="2" class="text-center pt-4 pt-lg-5 d-none d-lg-flex">
						<a :href="$creo.browserPdfLink(pdfLink.ansvarsfullt.org[$creo.getLang()], pdfLink.ansvarsfullt.fallback[$creo.getLang()], pdfLink.ansvarsfullt.page[$creo.getLang()])" target="_blank" class="text-black   text-decoration-none">
							<div class="img-hover-zoom">
								<b-img src="../assets/img/sam5.jpg" fluid/>
							</div>
							<p class="px-0 pt-3 small">
								<span v-if="$creo.getLang() == 'sv'">Ansvarsfullt agerande i alla led</span>
								<span v-else>Responsible decisions at all levels	</span>
							</p>
						</a>
					</b-col>
					<b-col cols="12" class="text-center py-4">
						<a 	:href="$creo.browserPdfLink(pdfLink.hallbart.org[$creo.getLang()], pdfLink.hallbart.fallback[$creo.getLang()], pdfLink.hallbart.page[$creo.getLang()])"
							target="_blank"
							class="btn btn-link pt-3 italic text-decoration-none standard-white">
							<span v-if="$creo.getLang() == 'sv'">Läs mer</span>
							<span v-else>Read more</span><span class="ml-2 arrow-gray float-right"></span>
						</a>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</section>
</template>
<script>
	import CModal from '@/components/Modal.vue'
	export default {
		props: {
			pdfLink: Object
		},
		data() {
			return {
				openId: 0
			}
		},
		components: {
			CModal
		},
		methods: {
			viewHandler(e) {
				// console.log(e)
			}
		}
	}
</script>
